import type { SuccessResponse } from '@/models/common';
import type {
  BulkUpdateUserInput,
  CreateUserInput, UpdateUserInput,
  User,
  UserDropdownResponse,
} from '@/models/user';

import { client } from '@/services/client';

export const userService = {
  getUsers() {
    return client.get<User[]>('/users');
  },
  getCompanies() {
    return client.get<string[]>('/users/companies');
  },

  getUser(id: string) {
    return client.get<User>(`/users/${id}`);
  },

  getCurrentUser() {
    return client.get<User>('/users/me');
  },

  createUser(input: CreateUserInput) {
    return client.post<User>('/users', input);
  },

  updateUser(id: string, input: UpdateUserInput) {
    return client.patch<User>(`/users/${id}`, input);
  },

  deleteUser(id: string): Promise<SuccessResponse> {
    return client.delete<SuccessResponse>(`/users/${id}`);
  },

  getDropdownValues(): Promise<UserDropdownResponse[]> {
    return client.get<UserDropdownResponse[]>('/users/dropdown');
  },

  bulkUpdateUsers(input: BulkUpdateUserInput): Promise<SuccessResponse> {
    return client.patch<SuccessResponse>('/users', input);
  },

  configureInitialSSOLogin(idToken: string): Promise<SuccessResponse> {
    return client.post<SuccessResponse>('/users/configure-initial-sso-login', { idToken });
  },
};
